import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import * as moment from "moment";
import { StorageService } from './storage.service';
@Injectable({
  providedIn: 'root'
})
export class ProductService {
  private url:string;
  constructor(private http:HttpClient,private storageService: StorageService) { 
    this.url=environment.urlService;
  }

  async gettypeMenu():Promise<number>{
    let result:number = await this.http.get<number>(this.url+'tipoMenu').toPromise();
    return result; 
  }

  getCategories():Observable<any>{
    return this.http.get(this.url+'categorias/'+this.storageService.getItem2("codRestaurante"));
  }

  getProductList(codCategoria):Observable<any>{
    return this.http.get(this.url+'productos/'+codCategoria+"/"+this.storageService.getItem2("codRestaurante"));
  }

  getProduct(codProducto):Observable<any>{
    return this.http.get(this.url+'producto/'+codProducto+"/0");
  }

  getValidate(product: any): boolean {
    let result: boolean = true;
    if (product.usarHorario == "1") {
      let date = new Date();
      let horaServer = product.horaServer.split(" ");
      switch (date.getDay()) {
        case 1:
          let lunes = product.lunes.split("-");
          result = this.validateDay(lunes,horaServer[1]);
          break;
        case 2:
          let martes = product.martes.split("-");
          result = this.validateDay(martes,horaServer[1]);
          break;
        case 3:
          let miercoles = product.miercoles.split("-");
          result = this.validateDay(miercoles,horaServer[1]);
          break;
        case 4:
          let jueves = product.jueves.split("-");
          result = this.validateDay(jueves,horaServer[1]);
          break;
        case 5:
          let viernes = product.viernes.split("-");
          result = this.validateDay(viernes,horaServer[1]);
          break;
        case 6:
          let sabado = product.sabado.split("-");
          result = this.validateDay(sabado,horaServer[1]);
          break;
        case 0:
          let domingo = product.domingo.split("-");
          result = this.validateDay(domingo,horaServer[1]);
          break;
      }
    }
    return result;
  }

  validateDay(day:any[],horaServer:any):boolean{
    let ini = moment(day[0], "HH:mm");
    let fin = moment(day[1], "HH:mm");
    let actual = moment(horaServer, "HH:mm");
    return actual.isBetween(ini, fin);
  }

}
 